import React from "react";
import styles from "./DataDocumentAccess.module.css";
import { HiDocumentText } from "react-icons/hi";
import { FaSearch } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { getAllDocumentPlans } from "../../../Services/APIrequests";
import { useEffect, useState } from "react";

const DataDocumentAccess = () => {
    const navigate = useNavigate();
    const [mcaData, setMcaData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getAllDocumentPlans();
                if (response.data.success) {
                    setMcaData(response.data.mcaDocumentsAndData);
                }
            } catch (error) {
                console.error("Error fetching MCA document plans:", error);
            }
        };
        fetchData();
    }, []);

    const handleViewPackages = () => {
        navigate("/", { state: { focusSearch: true } });
    };

    const handleViewDocuments = () => {
        navigate("/mca-documents");
    };

    // Find specific plans from API data
    const documentsPlan = mcaData.find(item => item.type === "documents") || {
        documentName: "MCA Documents Access",
        description: {
            heading: "Quick access to all public filings:",
            paragraphs: [
                "All documents filed on MCA portal",
                "Bulk download available as ZIP files",
                "Access all documents via the Dashboard for One Year"
            ]
        },
        price: 499
    };

    const reportsPlan = mcaData.find(item => item.type === "reports") || {
        documentName: "Company Research Reports",
        description: {
            heading: "In-depth company analysis at your fingertips:",
            paragraphs: [
                "Financial statements & balance sheets",
                "Director & shareholder details",
                "Compliance history & filing status"
            ]
        },
        price: 399
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1>
                    Data & Document <span className={styles.ServiceTitle}>Access</span>
                </h1>
                <p className={styles.subtitle}>
                    Instant access to corporate filings, reports & compliance data
                </p>
            </div>

            <div className={styles.grid}>
                {/* MCA Documents Access Card */}
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.iconWrapper}>
                            <HiDocumentText />
                        </div>
                        <h3 className={styles.cardTitle}>{documentsPlan.documentName}</h3>
                    </div>

                    <p className={styles.cardSubtitle}>{documentsPlan.description.heading}</p>

                    <ul className={styles.featuresList}>
                        {documentsPlan.description.paragraphs.map((para, index) => (
                            <li key={index} className={styles.featureItem}>
                                <FaCheck className={styles.checkmark} /> {para}
                            </li>
                        ))}
                    </ul>

                    <button style={{marginTop: '0px'}} className={styles.button} onClick={handleViewDocuments}>
                        Get Documents @ ₹{documentsPlan.price}
                    </button>

                </div>

                {/* Company Research Reports Card */}
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.iconWrapper}>
                            <FaSearch />
                        </div>
                        <h3 className={styles.cardTitle}>{reportsPlan.documentName}</h3>
                    </div>

                    <p className={styles.cardSubtitle}>{reportsPlan.description.heading}</p>

                    <ul className={styles.featuresList}>
                        {reportsPlan.description.paragraphs.map((para, index) => (
                            <li key={index} className={styles.featureItem}>
                                <FaCheck className={styles.checkmark} /> {para}
                            </li>
                        ))}
                    </ul>

                    <button className={styles.button} onClick={handleViewPackages}>
                        Get Reports @ ₹{reportsPlan.price}
                    </button>

                    {/* <p className={styles.footerText}>
                        Or Enjoy up to 50% discount with our credit packages <br />
                        <span className={styles.link} onClick={handleViewPackages}>View Credit Packages</span>
                    </p> */}
                </div>
            </div>
        </div>
    );
};

export default DataDocumentAccess;
